/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Aside_ActionInputs */

const en_auth_login_aside_action = /** @type {(inputs: Auth_Login_Aside_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an account`)
};

const pl_auth_login_aside_action = /** @type {(inputs: Auth_Login_Aside_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz konto`)
};

/**
* | output |
* | --- |
* | "Create an account" |
*
* @param {Auth_Login_Aside_ActionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_aside_action = /** @type {((inputs?: Auth_Login_Aside_ActionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Aside_ActionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_aside_action(inputs)
	return en_auth_login_aside_action(inputs)
});